module.exports = __webpack_public_path__ + "static/media/9DESA27.444e1c36.jpg";